import React from 'react'

const OptionalFieldFormLabel = () => (
    <span className="pl-1 has-text-weight-normal is-size-7 has-text-grey">(optional)</span>
)

export { OptionalFieldFormLabel }